<template>
  <div class="personal">
    <!-- 个人中心 -->
    <el-row class="per-box">
      <el-col :span="6">
        <!-- 侧边栏 -->
        <el-aside>
          <SideBar />
        </el-aside>
      </el-col>
      <el-col :span="18">
        <div class="personal_right">
          <!-- 主体 -->
          <router-view></router-view>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SideBar from "@/components/layout/sidebar.vue";
export default {
  components: {
    SideBar
  }
};
</script>

<style scoped lang="scss">
  .personal {
    width: 1200px;
    margin: 20px auto;
    .per-box{
      padding: 10px 0px;
      background-color: #fff;
    }
    .el-aside {
      text-align: left;
      min-height: 700px;
      background-color: #fff;
      
    }
  }
  .personal_right{
      text-align: left;
      padding: 20px 10px;
      // border:1px solid #ccc;
    min-height: 600px;
      background-color: #fff;
      border-left: 1px solid #e8e8e8;
  }

</style>


// WEBPACK FOOTER //
// src/components/personalcenter/personalcenter.vue